import type { StaffAssignmentRow } from "./types";

/** Mirrors the API's bulk cap (`ADMIN_STAFF_BULK_MAX`) for every bulk body. */
export const STAFF_BULK_MAX = 100;

/** Split a selection of rows into the `venueIds` / `propertyIds` body shape. */
export function selectionToIds(rows: readonly StaffAssignmentRow[]): {
  readonly venueIds?: readonly string[];
  readonly propertyIds?: readonly string[];
} {
  const venueIds = rows.filter((r) => r.kind === "venue").map((r) => r.entityId);
  const propertyIds = rows.filter((r) => r.kind === "property").map((r) => r.entityId);
  return {
    ...(venueIds.length > 0 ? { venueIds } : {}),
    ...(propertyIds.length > 0 ? { propertyIds } : {}),
  };
}
